import { render, staticRenderFns } from "./ActionButtonsV2.vue?vue&type=template&id=629bd3c6&scoped=true&lang=pug&v-cloak=true"
import script from "./ActionButtonsV2.vue?vue&type=script&lang=ts"
export * from "./ActionButtonsV2.vue?vue&type=script&lang=ts"
import style0 from "./ActionButtonsV2.vue?vue&type=style&index=0&id=629bd3c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629bd3c6",
  null
  
)

export default component.exports